"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emit = void 0;
const EventsToolkitSettings_1 = require("./EventsToolkitSettings");
const EventsToolkitUtilities_1 = require("./EventsToolkitUtilities");
const _1 = require(".");
const VisitorTracking_1 = require("./VisitorTracking");
const VisitorTracking_2 = require("./VisitorTracking");
const version_1 = require("./version");
const PREVIOUS_LOCATION_KEY = _1.visitorId + "-previous-location";
const NEXT_PAGE_VIEW_REFERRER_KEY = _1.visitorId + "-next-page-view-referrer";
const PageViewEvent = "web_analytics.tracking.page_view.PageViewEvent";
const UserInteractionEvent = "web_analytics.tracking.user_interaction.UserInteractionEvent";
function setPreviousLocation(locationHref, queryStringObject) {
    // we use session storage here to ensure this goes away when a browser window/tab is closed
    // but that it's also persisted if a browser session is restored.
    let referrer = getReferrerFromParams(queryStringObject);
    let preReferer = EventsToolkitUtilities_1.getSessionStorageItem(PREVIOUS_LOCATION_KEY);
    if (preReferer === "" && referrer !== undefined) {
        // set referrer if there's empty cache
        EventsToolkitUtilities_1.setSessionStorageItem(PREVIOUS_LOCATION_KEY, referrer);
    }
    else if ((referrer !== undefined && checkZapierDomain(referrer) && preReferer !== "") || (referrer === undefined && preReferer !== "")) {
        // do not overwrite referrer from storage if it's zapier domain or empty referrer
        return;
    }
    else if (referrer !== undefined && referrer !== preReferer && !checkZapierDomain(referrer)) {
        //  overwrite referrer if it's different from local storage and not zapier domain
        EventsToolkitUtilities_1.setSessionStorageItem(PREVIOUS_LOCATION_KEY, referrer);
    }
    else {
        //  default to current href
        EventsToolkitUtilities_1.setSessionStorageItem(PREVIOUS_LOCATION_KEY, locationHref);
    }
}
function getPreviousLocation(queryStringObject) {
    // we use "referer" to record where folks came from when they arrive in an app.
    // we also use it to record their previous location as they navigate around within
    // an app.   To ensure this works properly for Single Page Apps, we keep track
    // of this in session storage.
    let referrer = getReferrerFromParams(queryStringObject);
    if (referrer !== undefined && !checkZapierDomain(referrer)) {
        return referrer;
    }
    return EventsToolkitUtilities_1.getSessionStorageItem(PREVIOUS_LOCATION_KEY, document.referrer);
}
function removePreviousLocation() {
    return EventsToolkitUtilities_1.removeSessionStorageItem(PREVIOUS_LOCATION_KEY);
}
function removeNextPageViewReferrer() {
    return EventsToolkitUtilities_1.removeSessionStorageItem(NEXT_PAGE_VIEW_REFERRER_KEY);
}
function setNextPageViewReferrer(locationHref) {
    return EventsToolkitUtilities_1.setSessionStorageItem(NEXT_PAGE_VIEW_REFERRER_KEY, locationHref);
}
function getNextPageViewReferrer() {
    return EventsToolkitUtilities_1.getSessionStorageItem(NEXT_PAGE_VIEW_REFERRER_KEY, document.referrer);
}
function getReferrerFromParams(queryStringObject) {
    // As referer, referrer, from are being used in our code now so it's necessary to check all for the referer
    // For more detail: https://zapierorg.atlassian.net/browse/EV-1269
    let referer = queryStringObject.referer;
    let referrer = queryStringObject.referrer;
    let from = queryStringObject.from;
    if (referer !== undefined) {
        return referer || 'undefined';
    }
    if (referrer !== undefined) {
        return referrer || 'undefined';
    }
    if (from !== undefined) {
        return from || 'undefined';
    }
    return document.referrer;
}
function checkZapierDomain(url) {
    const regex = /zapier(-staging)?\.com/;
    return regex.test(url);
}
function applyDataGovernanceDefaults(eventData, eventType) {
    let page_path = null;
    let screen_size = null;
    let iframe_flag = EventsToolkitUtilities_1.isInIframe();
    let popup_flag = EventsToolkitUtilities_1.isInPopup();
    let user_agent = null;
    let url_address = null;
    let query_string = null;
    let fully_qualified_domain_name = null;
    let utm_campaign = null;
    let utm_content = null;
    let utm_medium = null;
    let utm_source = null;
    let visitor_id = null;
    let session_id = null;
    let page_view_id = null;
    let referer = null;
    let events_library_version = version_1.LIB_VERSION;
    let event_action = null;
    let interaction_name = null;
    let interaction_raw_text = null;
    if (EventsToolkitUtilities_1.isBrowser()) {
        fully_qualified_domain_name = window.location.hostname;
        url_address = window.location.href;
        page_path = window.location.pathname;
        query_string = window.location.search;
        user_agent = window.navigator.userAgent;
        var queryStringObject = EventsToolkitUtilities_1.querystringToObj(query_string);
        utm_campaign = queryStringObject.utm_campaign;
        utm_content = queryStringObject.utm_content;
        utm_medium = queryStringObject.utm_medium;
        utm_source = queryStringObject.utm_source;
        const width = window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;
        const height = window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight;
        screen_size = `${width}x${height}`;
        visitor_id = _1.visitorId;
        session_id = VisitorTracking_1.getSessionId();
        page_view_id = VisitorTracking_2.getPageViewId();
        if (eventType == UserInteractionEvent) {
            event_action = eventData.event_action || null;
            interaction_name = eventData.interaction_name || null;
            interaction_raw_text = eventData.interaction_raw_text || null;
        }
        if (eventType == PageViewEvent) {
            // We'll save the current url_address value for the PageViewEvent
            // as the "next PageViewEvent referrer"   This value will be used as
            // the next PageViewEvent's referer value to ensure this is consistently
            // tracked for Single Page Applications.
            // As we move to different pages, we'll keep track of our history
            // so we can use this as the "referrer" in Single Page Applications.
            // We don't immediately make the "next PageViewEvent referrer value" the
            // "previous location" as that can cause issues for referrer tracking
            // on other events like the UserInteractionEvent.
            setPreviousLocation(getNextPageViewReferrer(), queryStringObject);
            referer = getPreviousLocation(queryStringObject);
            setNextPageViewReferrer(url_address);
        }
        else {
            referer = getPreviousLocation(queryStringObject);
        }
    }
    return Object.assign({ fully_qualified_domain_name,
        url_address,
        query_string,
        page_path,
        screen_size,
        iframe_flag,
        popup_flag,
        user_agent,
        utm_content,
        utm_medium,
        utm_source,
        utm_campaign,
        visitor_id,
        page_view_id,
        referer,
        session_id,
        events_library_version,
        interaction_name,
        interaction_raw_text,
        event_action }, eventData);
}
function writeToDataLayer(eventType, eventData) {
    if (EventsToolkitUtilities_1.isBrowser() && EventsToolkitSettings_1.settings.write_to_data_layer === "true") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "analyticsEvent",
            eventLabel: eventType,
            eventAction: eventData.event_action,
            interactionName: eventData.interaction_name,
            interactionRawText: eventData.interaction_raw_text,
            pagePath: eventData.page_path,
            visitorId: _1.visitorId,
        });
    }
}
if (typeof window !== 'undefined') {
    window.addEventListener("beforeunload", () => {
        removePreviousLocation();
        removeNextPageViewReferrer();
    });
}
function emit(eventData, eventType) {
    return __awaiter(this, void 0, void 0, function* () {
        let emitStatus = true;
        let eventRequestData = undefined;
        try {
            eventRequestData = applyDataGovernanceDefaults(eventData, eventType);
            const response = yield fetch(EventsToolkitSettings_1.settings.emit_api, {
                body: JSON.stringify({
                    properties: eventRequestData,
                    subject: eventType,
                }),
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/json",
                },
                method: "POST",
                // Allow the request to outlive the page context it was created from.
                // Without this flag, events fired shortly before a full page navigation
                // will be cancelled by the browser if the request doesn't finish before
                // the page is shut down. This results in lost events.
                keepalive: true,
            });
            if (response.status !== 200) {
                console.warn("Unable to emit event:", response);
                emitStatus = false;
            }
            else {
                writeToDataLayer(eventType, eventRequestData);
            }
        }
        catch (error) {
            console.warn("Unable to emit event:", error);
            emitStatus = false;
        }
        return [emitStatus, eventRequestData];
    });
}
exports.emit = emit;
